export default {"src":"/_next/static/media/gv-logo.011a2e1a.svg","height":70,"width":127,"blurWidth":0,"blurHeight":0};